import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import { useParams } from 'react-router-dom'
import Section from '../../components/layout/Section';
import ContentCard from '../../components/layout/ContentCard';
import ContentPlain from '../../components/layout/ContentPlain';
import ClientActions from '../../store/clientRedux';
import ClientBasicPersonalInformation from './components/ClientBasicPersonalInformation';
import QuickLinks from './components/QuickLinks';
import PurchaseHistory from './components/PurchaseHistory';

import './ClientInfoPage.scss'

const ClientInfoPage = () => {
    const dispatch = useDispatch();
    const { id } = useParams();

    const client = useSelector(state => state.client.selectedClient)

    useEffect(() => {   
        dispatch(ClientActions.getClient(id))
    }, [id]);

    return (
        <div className="content-grid">
            <Section sectionId='section-personal-info' className='white'>
                <ContentPlain elementId='content-greeting'>
                    <ClientBasicPersonalInformation client={client} />
                </ContentPlain>
            </Section>
            <Section sectionId='section-returns' className='light-functional-grey'>
                <ContentCard elementId='client-returns' titleKey='Account.Headers.Returns'>
                    <PurchaseHistory />
                </ContentCard>
                <ContentCard elementId='quick-links' titleKey='HomePage.Labels.QuickLinks'>
                    <QuickLinks />
                </ContentCard>
            </Section>
        </div>
    );
}

ClientInfoPage.whyDidYouRender = false;

export default ClientInfoPage